import markerImage from '../../../../../../../assets/images/icons/marker.png';

const Marker = ({text}) => {
    return(<div className='Marker'>
        <img src={markerImage} width="40" height={'auto'} alt="Marker" />
    </div>);
}


export default Marker;